import { List as MUIList, ListProps as MUIListProps } from '@mui/material';

export interface ListProps extends MUIListProps {}

export const List = MUIList;
